<div class="filter-floors">
  <div class="modal-main">
    <div class="header my-4">
      <div class="header">
        <div class="d-flex justify-content-between">
          <h1 class="modal-title m-auto text-center heading1">
            {{ "FILTER_ACTIVITIES" | translate }}
          </h1>
          <!-- dynamic back button render -->
          <ng-content select="[backButton]"></ng-content>
        </div>
      </div>

      <ng-container *ngIf="stepper === 1">
        <div class="row my-4 mx-3 pt-1 justify-content-between">
          <div class="col-2"></div>
          <div class="col-4 mr-4">
            <p class="text-center heading1">
              {{ "FILTER_BY" | translate }}
            </p>
          </div>
          <div
            class="col-2 reset-btn"
            role="button"
            (click)="resetFilter()"
            [ngClass]="{
              'reset-btn-active': hasSelection
            }"
          >
            <p class="text-right">
              {{ "RESET" | translate }}
            </p>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="scroll-container mb-32">
      <!-- Date Range -->
      <div
        class="row py-2 filter-item pointer-cursor top-element"
        (click)="navigateTo(4)"
      >
        <div
          class="col-2 text-center d-flex flex-row justify-content-center align-items-center"
        >
          <img src="assets/svg/ico-calendar-clear-outline.svg" class="icon" />
        </div>
        <div class="col-8 text-item d-flex flex-column justify-content-center">
          <p class="item-title">
            {{ "DATE_RANGE" | translate }}
          </p>
          <p class="item-description ellipsis mb-0">
            <app-with-tooltip [showHelpCursor]="true">
              {{ dateFormat }}
            </app-with-tooltip>
          </p>
        </div>

        <div
          class="col-2 text-right d-flex flex-row justify-content-end align-items-center pr-3 pointer-cursor"
          role="button"
        >
          <img src="assets/svg/ico-chevron-forward-outline.svg" />
        </div>
      </div>

      <!-- User Type -->
      <div
        class="row py-2 filter-item pointer-cursor middle-element"
        (click)="navigateTo(2)"
      >
        <div
          class="col-2 text-center d-flex flex-row justify-content-center align-items-center"
        >
          <img src="assets/svg/ico-user-group-gray.svg" class="icon" />
        </div>
        <div class="col-8 text-item d-flex flex-column justify-content-center">
          <p class="item-title">
            {{ "USER_TYPE" | translate }}
          </p>
          <p class="item-description ellipsis mb-0">
            <app-with-tooltip [showHelpCursor]="true">
              {{ userTypeLabel }}
            </app-with-tooltip>
          </p>
        </div>

        <div
          class="col-2 text-right d-flex flex-row justify-content-end align-items-center pr-3 pointer-cursor"
          role="button"
        >
          <img src="assets/svg/ico-chevron-forward-outline.svg" />
        </div>
      </div>

      <!-- Activity Type -->
      <div
        class="row py-2 filter-item pointer-cursor last-element"
        (click)="navigateTo(3)"
      >
        <div
          class="col-2 text-center d-flex flex-row justify-content-center align-items-center"
        >
          <img src="assets/svg/ico-history.svg" class="icon" />
        </div>
        <div class="col-8 text-item d-flex flex-column justify-content-center">
          <p class="item-title">
            {{ "ACTIVITY_TYPE" | translate }}
          </p>
          <p class="item-description ellipsis mb-0">
            <app-with-tooltip [showHelpCursor]="true">
              {{ activityTypeLabel }}
            </app-with-tooltip>
          </p>
        </div>

        <div
          class="col-2 text-right d-flex flex-row justify-content-end align-items-center pr-3 pointer-cursor"
          role="button"
        >
          <img src="assets/svg/ico-chevron-forward-outline.svg" />
        </div>
      </div>
    </div>

    <div class="row">
      <button
        class="btn btn-danger px-3 w-100 result-btn"
        type="button"
        (click)="applyFilter()"
      >
        {{ "SEE_RESULTS" | translate }}
      </button>
    </div>
  </div>
</div>
